export default __webpack_public_path__ + "static/media/acct-nav.31730543.png";